import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../../constants/languages";
import TextField from "@material-ui/core/TextField";

export default class EditSlideshowDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {languages.present.editSlideshow}
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
            <TextField
              margin="dense"
              label={languages.general.name}
              value={this.props.name}
              name="name"
              onChange={this.props.handleChange}
              type="text"
              fullWidth
            />
            {this.props.deleteConfirm && (
              <div style={{ color: "red", marginTop: 10 }}>
                {languages.present.deleteSlideshowDescription}
              </div>
            )}
          </DialogContent>
          <DialogActions>
            {this.props.slideshow.id !== "0" && (
              <Button onClick={this.props.handleDelete} color="secondary">
                {languages.general.delete}
              </Button>
            )}
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.props.handleSubmit}
              variant="contained"
              color="primary"
              type="submit"
            >
              {languages.general.save}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
